import React, { useEffect, useRef } from "react";
import CurrencyInput from "react-currency-input-field";

type Props = {
	price: string;
	setPrice: (value: string) => void;
};

const AmountInputBox = React.forwardRef<
	HTMLInputElement | null,
	Props & React.InputHTMLAttributes<HTMLInputElement>
>(({ price, setPrice, ...rest }) => {
	const inputRef = useRef<HTMLInputElement>(null);

	// Focus the input on mount
	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.focus();
		}
	}, []);

	const { defaultValue, step, ...currencyInputProps } = rest;

	return (
		<div className="w-full flex justify-center items-center">
			<div className="flex items-center">
				<CurrencyInput
					allowNegativeValue={false}
					className="p-0 text-4xl font-bold border-none focus:outline-none focus:ring-0 focus:border-none text-textDark text-center"
					value={price}
					prefix="$"
					data-testid="amount-input"
					maxLength={8}
					onValueChange={(value) => setPrice(value ?? "")}
					placeholder="$25,000.00"
					ref={inputRef}
					{...currencyInputProps}
				/>
			</div>
		</div>
	);
});

export default AmountInputBox;
